import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ScreenService } from '../../services/screen.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debug } from 'util';

@Component({
  selector: 'app-schduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.css']
})
export class SchedulerComponent implements OnInit, OnDestroy {
  private currentUser: any;
  private currentXmls: Array<any> = [];
  public currentSchduleFiles: Array<any> = [];
  private scheduleFilesData: Array<any> = [];
  public availableList: Array<any> = [];
  private selectedList: Array<any> = [];
  public schedulerName: String = '';
  private gContentDirectory = '../Content/';
  private gActiveResolution = '1280x720';
  public scheduled_screen_attributes = [];
  isSavingFile: boolean;
  isPublishing: boolean;
  isScreenSaved: boolean;
  public selectedScheduleFile;
  private modalRef;
  private defaultSchedule = null;
  public currentUserServers: Array<any> = [];
  private selectedScreenForSchdule;
  private selectedYear = 'Now';
  private selectedMonth = 'Now';
  private selectedDate = 'Now';
  private selectedHour = 'Now';
  private selectedMinute = 'Now';
  private selectedEndYear = 'Never';
  private selectedEndMonth = 'Never';
  private selectedEndDate = 'Never';
  private selectedEndHour = 'Never';
  private selectedEndMinute = 'Never';
  private selectedWeekdays = ['All'];
  public selectedChannel = 0;
  // private selectedPublishChannel = { iD: 0, endpointLocationName: '-- Groups --' };
  public selectedPublishChannel = '0';
  private scheduleFiles = [];
  private imageFiles = [];
  private videoFiles = [];
  private otherFiles = [];
  private error = false;

  private months = ['Jan', 'Feb', 'Mar', 'Apr',
    'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  private weekDays = [
    { name: 'Sun', value: 'Sun', checked: true },
    { name: 'Mon', value: 'Mon', checked: true },
    { name: 'Tue', value: 'Tue', checked: true },
    { name: 'Wed', value: 'Wed', checked: true },
    { name: 'Thu', value: 'Thu', checked: true },
    { name: 'Fri', value: 'Fri', checked: true },
    { name: 'Sat', value: 'Sat', checked: true }
  ];

  private years = [];
  private dates = [];
  private hours = [
    'Midnight',
    '1am',
    '2am',
    '3am',
    '4am',
    '5am',
    '6am',
    '7am',
    '8am',
    '9am',
    '10am',
    '11am',
    '12 Noon',
    '1pm',
    '2pm',
    '3pm',
    '4pm',
    '5pm',
    '6pm',
    '7pm',
    '8pm',
    '9pm',
    '10pm',
    '11pm'
  ];
  private minutes = [];

  public availableChannels = [
    '95',
    '96',
    '97',
    '98',
    '99'
  ];

  @ViewChild('schedulerCalendarModal') private schedulerCalendarModal;

  constructor(
    private authService: AuthService,
    private screenService: ScreenService,
    private modalService: NgbModal
  ) {
    this.currentUser = this.authService.currentUser;
  }

  ngOnInit() {
    const currYear = new Date().getFullYear();

    for (let i = 0; i < 31; i++) {
      this.years.push(currYear + i + '');
      this.dates.push(i + 1 + '');
    }
    for (let i = 0; i < 60; i = i + 5) {
      this.minutes.push(i < 10 ? (':0' + i) : ':' + i);
    }
    // this.initialize();

    this.availableList = [];
    this.currentSchduleFiles = [];
    this.currentXmls = [];

    this.screenService.getCurrentUserFiles().subscribe((response) => {
      this.currentXmls = response.data.xmls;
      this.currentSchduleFiles = response.data.scheduleFiles;
      this.readScreenlistFileDetails();
      this.readScheduleFileDetails();
      this.selectedScheduleFile = 0;
    });

    this.getCurrentUserServers();
  }

  initialize() {
    this.currentSchduleFiles = [];
    this.currentXmls = [];
    this.screenService.getCurrentUserFiles().subscribe((response) => {
      this.currentXmls = response.data.xmls;
      this.currentSchduleFiles = response.data.scheduleFiles;
      // this.readScreenlistFileDetails();
      this.readScheduleFileDetails();
      this.selectedScheduleFile = 0;
    });
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  drag(ev) {
    ev.dataTransfer.setData('drag_id', ev.target.id);
  }

  drop(ev) {
    let data = ev.dataTransfer.getData('drag_id');
    data = data.split('_');
    const listName = data[0];
    const id = data[1];
    // const dropZone = ev.target.attributes['id'].value.split('_')[0];
    if (listName === 'avail') {
      this.selectedList.push(this.availableList[id]);
      this.generateScreensSchedule(this.availableList[id]);
    }
  }

  readScreenlistFileDetails() {
    let userName = '';
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    const reqData = {
      userName: userName,
      fileName: null,
      templatesRelativePath: null
    };

    this.currentXmls.forEach((item) => {
      reqData.fileName = item.name;
      this.screenService.readScreenlistFile(reqData).subscribe((response) => {
        response.data.screenlist.channelNumber = this.getChannelNumber(item.name);
        this.availableList.push(response.data.screenlist);
      }, (error) => {
        console.log(error);
      });
    });
  }

  getCurrentUserServers() {
    this.screenService.getUserServerList(this.authService.currentUser.userID).subscribe((response) => {
      // this.currentUserServers.push(this.selectedPublishChannel);
      response.data.forEach(element => {
        this.currentUserServers.push(element.endpointLocationName);
      });
      // this.currentUserServers = this.currentUserServers.concat(response.data);
    }, (error) => {
      console.log(error);
    });
  }

  readScheduleFileDetails() {
    let userName = '';
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    const reqData = {
      userName: userName,
      fileName: null,
      templatesRelativePath: null
    };

    this.currentSchduleFiles.forEach((item) => {
      const id = this.generateRandomId();
      reqData.fileName = item.name;
      this.screenService.readScheduleFile(reqData).subscribe((response) => {
        this.scheduleFilesData.push({
          id: id,
          channelNum: item.name.substr(15, 2),
          name: response.data.scheduleScreenList.name,
          data: response.data.scheduleScreenList.scheduleScreens
        });
        item.channelNum = item.name.substr(15, 2);
        item.name = response.data.scheduleScreenList.name;
        item.id = id;
      }, (error) => {
        console.log(error);
      });
    });
  }

  createScreenList(): object {
    // set the global variable name to the just provided screenlist name

    // *****************************************************
    // ** Get each of the required values to be entered into the file **
    // *****************************************************
    const dmb_attributes = {
      'version': '1.0',
      'timestamp': this.currentTimeStamp()
    };

    const screenlist_attributes = {
      'filename': 'dmb.screenlist.' + this.selectedChannel + '.xml',
      'name': this.schedulerName ? this.schedulerName : 'Sign_' + Math.floor((Math.random() * 6) + 1),
      'resolution': this.gActiveResolution,
      'content_directory': this.gContentDirectory
    };

    // To re-arrange default screen to bottom
    const screen = this.scheduled_screen_attributes[this.defaultSchedule];
    this.scheduled_screen_attributes.splice(this.defaultSchedule, 1);
    this.scheduled_screen_attributes.push(screen);
    this.defaultSchedule = this.scheduled_screen_attributes.length - 1;

    return {
      UserName: this.currentUser.userName,
      userID: this.currentUser.userID,
      DmbAttributes: dmb_attributes,
      ScreenlistAttributes: screenlist_attributes,
      ScheduledScreensObjects: this.scheduled_screen_attributes
    };
  }

  generateScreensSchedule(screenElement, existingSelected = false) {
    const scheduleScreenObj = {
      'ScreenAttributes': null,
      'ScreenAssets': null,
      'name': screenElement.name,
      'id': this.generateRandomId(),
      'scheduleString': screenElement.schedule_string ? screenElement.schedule_string : ''
    };

    scheduleScreenObj.ScreenAttributes = {
      'name': screenElement.name,
      'on_boot_only': screenElement.screen.on_boot_only,
      'active': screenElement.screen.active,
      'background_color': screenElement.screen.background_color,
      'exit_on_video_end': screenElement.screen.exit_on_video_end
    };

    scheduleScreenObj.ScreenAssets = screenElement.screen.asset;
    this.scheduled_screen_attributes.push(scheduleScreenObj);

    if (!screenElement.schedule_string && existingSelected) {
      this.defaultSchedule = this.scheduled_screen_attributes.indexOf(scheduleScreenObj);
    }

  }
  /**
   *  Once the user has entered the screenlist file name, create or update the xml file in the 'Contnet' directory
   */
  createScheduleXML(): void {
    if (this.selectedChannel === 0) {
      this.authService.showNotification('Please select Channel to save', 'error');
      return;
    }

    if (this.defaultSchedule === null) {
      this.authService.showNotification('Please select Default screen', 'error');
      return;
    }

    if (this.scheduled_screen_attributes.length < 2) {
      this.authService.showNotification('Please select atleast two screen', 'error');
      return;
    }

    this.error = false;

    this.scheduled_screen_attributes.forEach(element => {
      if (!element.scheduleString &&
        this.scheduled_screen_attributes.indexOf(element) !== this.defaultSchedule) {
        this.authService.showNotification('Please configure the schedule', 'error');
        this.error = true;
      }
    });

    if (this.error) {
      return;
    }

    const data = this.createScreenList();
    this.isSavingFile = true;
    this.screenService.saveScheduleXmlFile(data).subscribe((response) => {
      this.authService.showNotification('Screen saved successfully', 'success', 'success');
      this.isSavingFile = false;
      this.isScreenSaved = true;
      this.isSavingFile = false;
      this.initialize();
    }, error => {
      this.authService.showNotification('Some error occured please try again later', 'error');
      this.isSavingFile = false;
    });
  }

  currentTimeStamp(): string {
    const date = new Date();
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const minutes = date.getMinutes();
    const hours = date.getHours();
    const seconds = date.getSeconds();
    const myFormattedDate = day + '-' + (monthIndex + 1) + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds;
    return myFormattedDate;
  }

  scheduleChanged($event) {
    this.scheduled_screen_attributes = [];
    this.scheduleFiles = [];
    this.otherFiles = [];
    this.videoFiles = [];
    this.imageFiles = [];
    this.scheduleFilesData.forEach((item) => {
      if (item.id === $event) {
        item.data.forEach(element => {
          element.screen = element;
          this.generateScreensSchedule(element, true);
        });
        this.selectedChannel = item.channelNum;
        this.schedulerName = item.name;
        return;
      }
    });
  }

  prepareAssetList(screenAsset) {
    screenAsset.forEach(element => {
      if (element.playlist && element.playlist_items.length > 0) {
        this.otherFiles.push(element.playlists.file_name);
        element.playlist_items.forEach(plItem => {
          if (plItem.type === 'image' && plItem.name) {
            this.imageFiles.push(plItem.name);
          } else if (plItem.type === 'video' && plItem.name) {
            this.videoFiles.push(plItem.name);
          }
        });
      } else if (element.type === 'image' && element.source) {
        this.imageFiles.push(element.source);
      } else if (element.type === 'video' && element.source) {
        this.videoFiles.push(element.source);
      }
    });
  }

  removeScreen(index) {
    if (this.defaultSchedule === index) {
      this.defaultSchedule = null;
    }
    this.scheduled_screen_attributes.splice(index, 1);
  }

  generateRandomId() {
    return '_' + Math.random().toString(36).substr(2, 9);
  }

  showSchedulerCalendar(screen) {
    this.selectedScreenForSchdule = screen;
    if (screen.scheduleString !== '') {
      this.readScheduleFile(screen.scheduleString);
    } else {
      this.resetScheduleFile();
    }
    this.openModel(this.schedulerCalendarModal, { size: 'lg' });
  }

  openModel(content, config?: object, type?: string) {
    if (typeof config === 'undefined') {
      config = {};
    }
    this.modalRef = this.modalService.open(content, config);

    this.modalRef.result.then((result) => {
      console.log('`Closed with: ${result}`');
    }, (reason) => {
      console.log('`Dismissed ${this.getDismissReason(reason)}`');
    });
  }

  readScheduleFile(scheduleString: String) {
    const scheduleStringArray = scheduleString.split(';');

    const startDate = scheduleStringArray[0].split('/');
    const endDate = scheduleStringArray[1].split('/');
    const startTime = scheduleStringArray[2].split(':');
    const endTime = scheduleStringArray[3].split(':');
    const weekdays = scheduleStringArray[4].split(',');

    this.selectedMonth = startDate[0] === '*' ? 'Now' : this.selectMonth(startDate[0]);
    this.selectedDate = startDate[1] === '*' ? 'Now' : startDate[1];
    this.selectedYear = startDate[2] === '*' ? 'Now' : startDate[2];
    this.selectedEndMonth = endDate[0] === '*' ? 'Never' : this.selectMonth(endDate[0]);
    this.selectedEndDate = endDate[1] === '*' ? 'Never' : endDate[1];
    this.selectedEndYear = endDate[2] === '*' ? 'Never' : endDate[2];
    this.selectedHour = startTime[0] === '*' ? 'Now' : this.selectHour(startTime[0]);
    this.selectedMinute = startTime[1] === '*' ? 'Now' : ':' + startTime[1];
    this.selectedEndHour = endTime[0] === '*' ? 'Never' : this.selectHour(endTime[0]);
    this.selectedEndMinute = endTime[1] === '*' ? 'Never' : ':' + endTime[1];

    this.weekDays = [
      { name: 'Sun', value: 'Sun', checked: false },
      { name: 'Mon', value: 'Mon', checked: false },
      { name: 'Tue', value: 'Tue', checked: false },
      { name: 'Wed', value: 'Wed', checked: false },
      { name: 'Thu', value: 'Thu', checked: false },
      { name: 'Fri', value: 'Fri', checked: false },
      { name: 'Sat', value: 'Sat', checked: false }
    ];

    weekdays.forEach(element => {
      this.weekDays.filter((item) => {
        if (item.value === element) {
          item.checked = true;
        }
      });
    });
  }

  selectHour(value) {
    switch (value) {
      case '0':
        return 'Midnight';
      case '12':
        return '12 Noon';
      default:
        if (parseInt(value, 10) > 12) {
          return (value - 12) + 'pm';
        } else {
          return value + 'am';
        }
    }
  }

  selectMonth(value: String) {
    switch (value) {
      case '1':
        return 'Jan';
      case '2':
        return 'Feb';
      case '3':
        return 'Mar';
      case '4':
        return 'Apr';
      case '5':
        return 'May';
      case '6':
        return 'Jun';
      case '7':
        return 'Jul';
      case '8':
        return 'Aug';
      case '9':
        return 'Sep';
      case '10':
        return 'Oct';
      case '11':
        return 'Nov';
      case '12':
        return 'Dec';
    }
  }

  createScheduleFile() {
    // const screen = this.scheduled_screen_attributes.filter(opt => opt.id === this.selectedScreenForSchdule.id);

    this.scheduled_screen_attributes.forEach(element => {
      if (element.id === this.selectedScreenForSchdule.id) {
        element.scheduleString = this.getMonth(this.selectedMonth) + '/' +
          this.computeValue(this.selectedDate) + '/' +
          this.computeValue(this.selectedYear) + ';' +
          this.getMonth(this.selectedEndMonth) + '/' +
          this.computeValue(this.selectedEndDate) + '/' +
          this.computeValue(this.selectedEndYear) + ';' +
          this.computeHour(this.selectedHour) + ':' +
          this.computeMinute(this.selectedMinute) + ';' +
          this.computeHour(this.selectedEndHour) + ':' +
          this.computeMinute(this.selectedEndMinute) + ';' +
          this.selectedOptions();
      }
    });

    this.modalRef.close();
    this.resetScheduleFile();
  }

  resetScheduleFile() {
    this.selectedYear = 'Now';
    this.selectedMonth = 'Now';
    this.selectedDate = 'Now';
    this.selectedHour = 'Now';
    this.selectedMinute = 'Now';
    this.selectedEndYear = 'Never';
    this.selectedEndMonth = 'Never';
    this.selectedEndDate = 'Never';
    this.selectedEndHour = 'Never';
    this.selectedEndMinute = 'Never';
    this.weekDays = [
      { name: 'Sun', value: 'Sun', checked: true },
      { name: 'Mon', value: 'Mon', checked: true },
      { name: 'Tue', value: 'Tue', checked: true },
      { name: 'Wed', value: 'Wed', checked: true },
      { name: 'Thu', value: 'Thu', checked: true },
      { name: 'Fri', value: 'Fri', checked: true },
      { name: 'Sat', value: 'Sat', checked: true }
    ];
  }
  computeHour(hour) {
    if (hour === 'Never' || hour === 'Now') {
      return '*';
    } else if (hour === 'Midnight') {
      return '0';
    } else if (hour === '12 Noon') {
      return '12';
    } else if (hour.includes('am')) {
      return hour.replace('am', '');
    } else if (hour.includes('pm')) {
      return (parseInt(hour.replace('pm', ''), 10) + 12) + '';
    }
  }

  computeValue(value) {
    if (value === 'Never' || value === 'Now') {
      return '*';
    } else {
      return value;
    }
  }

  computeMinute(value) {
    value = this.computeValue(value);

    if (value.includes(':')) {
      return value.substr(1);
    }
    return value;
  }

  getMonth(month) {
    if (month === 'Never' || month === 'Now') {
      return '*';
    } else {
      switch (month) {
        case 'Jan':
          return 1;
        case 'Feb':
          return 2;
        case 'Mar':
          return 3;
        case 'Apr':
          return 4;
        case 'May':
          return 5;
        case 'Jun':
          return 6;
        case 'Jul':
          return 7;
        case 'Aug':
          return 8;
        case 'Sep':
          return 9;
        case 'Oct':
          return 10;
        case 'Nov':
          return 11;
        case 'Dec':
          return 12;
      }
    }
  }

  selectedOptions() {
    let selectedWeekday = '';
    this.weekDays
      .filter(opt => opt.checked)
      .map((opt) => {
        if (selectedWeekday !== '') {
          selectedWeekday += ',' + opt.value;
        } else {
          selectedWeekday = opt.value;
        }
      });
    return selectedWeekday;
  }

  setDefaultScreen(index) {
    if (this.defaultSchedule === index) {
      this.defaultSchedule = null;
    } else {
      this.defaultSchedule = index;
    }
    this.scheduled_screen_attributes[index].scheduleString = '';
  }

  publish() {

    this.scheduleFiles = [];

    this.scheduled_screen_attributes.forEach(element => {
      this.prepareAssetList(element.ScreenAssets);
      if (element.scheduleString !== '') {
        this.scheduleFiles.push(element.name.split(' ').join('_') + '.sc');
      }
    });

    let userName = '';
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }

    if (this.selectedPublishChannel === '0' || !this.authService.currentUser || this.selectedChannel === 0) {
      return;
    }
    const filesToUpload = {
      images: this.imageFiles,
      videos: this.videoFiles,
      xmls: ['dmb.screenlist.' + this.selectedChannel + '.xml'],
      isScreenScheduler: true,
      userName: userName,
      serverName: 'content server',
      others: this.otherFiles,
      schedules: this.scheduleFiles,
      EndpointLocationName: this.selectedPublishChannel.toLowerCase(),
      endpointLocationName: this.selectedPublishChannel.toLowerCase(),
    };
    this.isPublishing = true;
    this.screenService.previewScreenlistFile(filesToUpload).subscribe((response) => {
      if (response.status === 'error') {
        // this.authService.showNotification('', response.message, 'error');
        this.authService.showNotification('', 'Error: Publish failed', 'error');
      } else {
        // this.authService.showNotification(response.message, 'success');
        this.authService.showNotification('Publish Successful', 'success', 'success');
      }
      this.isPublishing = false;
    }, error => {
      this.isPublishing = false;
      this.authService.showNotification('Some error occured please try again later', 'error');
    });


  }

  getChannelNumber(fileName: String) {
    const fileContents = fileName.split('.');
    const channelNumber = parseInt(fileContents[fileContents.length - 2], 10);
    if (channelNumber === 0) {
      return 'Default';
    }
    return 'Ch. ' + channelNumber;
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/scheduler/scheduler.component.ts